import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Grid } from "@mui/material";
import {
  columnsBackgroundInputs,
  columnsBackgrounResultdInputs,
} from "../../utils/background.columns";
import { calculateMedia } from "../../utils/helpers";

import { MButton } from "@app/components";
import { useFormContext } from "react-hook-form";
import { initialRowsCalculation } from "../../utils/calculation.rows";
import { useBackground } from "../../utils/useBackground";
import { errorAlert } from "../../../../utils/alerts";
import { TYPE_RESULT_TABLE } from "../../utils/constans";
import { mean } from "mathjs";

const AlfaBetaForms = ({ disable }: { disable: boolean }) => {
  const form = useFormContext();
  const { watch, setValue, getValues } = useFormContext();
  const { fetchReferenceCodeTypeValues } = useBackground();

  const rowsCalculation = watch("rowsCalculation");
  const [rowsInput, setRowsInput] = useState(getValues("rowsInput"));
  const [rowsResult, setRowsResult] = useState(getValues("rowsResult"));

  useEffect(() => {
    if (!rowsCalculation || rowsCalculation.length === 0) {
      setValue("rowsCalculation", initialRowsCalculation);
    }
  }, [rowsCalculation, setValue]);

  const processRowUpdate = (newRow) => {
    const updatedRows = calculateMedia(newRow, rowsInput);
    setValue("rowsCalculation", updatedRows);
    setRowsInput(updatedRows);
    return newRow;
  };

  const calculateResults = async () => {
    setValue("calculation_date", new Date());
    const code = form.getValues("code");
    const equipment = form.getValues("equipment");

    if (!code) {
      errorAlert("Debe seleccionar un código antes de calcular.");
      return;
    }

    if (!equipment) {
      errorAlert("Debe seleccionar un equipo antes de calcular.");
      return;
    }

    const type = form.getValues("type")?.value;
    const fondoId = form.getValues("id") || "-";
    
    try {
      const updatedRowsWithReferences = await fetchReferenceCodeTypeValues(
        fondoId,
        code?.tipo_codigo,
        type,
        equipment?.id
      );

      const fondoCalculation =
        updatedRowsWithReferences?.["fondo_calculation"] || [];

      const updatedResults = rowsInput.map((row, index) => {
        const referenceValue = fondoCalculation[index]?.["value_to_apply"] || 0;
        const referenceValueOfReferenceValue =
          fondoCalculation[index]?.["reference_value"] || 0;
        const variationValue = fondoCalculation[index]?.["variation"] || 0;
        const referenceMedia = fondoCalculation[index]?.["media"] || 0;
        const values = [row.cpm1, row.cpm2, row.cpm3, row.cpm4];
        const sum = values.reduce((acc, val) => acc + Number(val || 0), 0);
        const countValues = values.filter((val) => val != null && val !== 0);
        const media =
          countValues.length > 0
            ? parseFloat((sum / countValues.length / 1000).toFixed(4))
            : 0;

        const variation =
          media !== 0 && referenceValue !== 0
            ? (media / referenceValue - 1) * 100
            : 0;

        const cpmValues = [row.cpm1, row.cpm2, row.cpm3, row.cpm4];
        const validCpmCount = cpmValues.reduce((count, value) => {
          return count + (value != null && value !== 0 ? 1 : 0);
        }, 0);

        let result: string = TYPE_RESULT_TABLE.KEEP;
        const sameSign = variationValue * variation > 0;
        const sameReference = referenceValue === referenceValueOfReferenceValue;
        const sameSignAndReference = sameSign && sameReference;

        if (media !== 0 && referenceValue === 0) {
          result = TYPE_RESULT_TABLE.CHANGE;
        }

        if (validCpmCount === 1) {
          if (
            sameSignAndReference &&
            Math.abs(variation) > 10 &&
            Math.abs(variationValue) > 10
          ) {
            result = TYPE_RESULT_TABLE.CHANGE;
          }
        } else if (validCpmCount > 1) {
          if (Math.abs(variation) > 10) {
            result = TYPE_RESULT_TABLE.CHANGE;
          }
        }

        let value_to_apply = referenceValue;
        if (result === TYPE_RESULT_TABLE.CHANGE && referenceValue !== 0) {
          value_to_apply =
            validCpmCount === 1
              ? mean(media, referenceMedia)
              : validCpmCount > 1
              ? media
              : 0;
        }

        return {
          ...rowsResult[index],
          media: media,
          reference_value: referenceValue,
          variation: variation.toFixed(2),
          result: result,
          value_to_apply:
            media !== 0 && value_to_apply === 0 ? media : value_to_apply,
        };
      });

      setRowsResult(updatedResults);
      setValue("results", updatedResults);
    } catch (error) {
      console.error("Error fetching reference values:", error);
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100%", display: "flex", gap: 0 }}>
              <Box sx={{ flex: 1 }}>
                <DataGrid
                  key={"data-input"}
                  rows={rowsInput}
                  columns={columnsBackgroundInputs}
                  disableRowSelectionOnClick
                  processRowUpdate={processRowUpdate}
                  hideFooterPagination
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  justifyContent: "center",
                  alignItems: "center",
                  ml: 2,
                }}
              >
                <MButton onClick={calculateResults} text="Calcular" />
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100%", display: "flex", gap: 0 }}>
              <Box sx={{ flex: 1 }}>
                <DataGrid
                  key={"data-result"}
                  rows={rowsResult}
                  columns={columnsBackgrounResultdInputs}
                  disableRowSelectionOnClick
                  hideFooterPagination
                  getRowClassName={(params) => params.row.className}
                />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default AlfaBetaForms;
